/**
 * odor-summary.js
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Types } from 'utils/constants';
import { displayNumber } from 'utils/misc';
import InfoRow from 'components/info-row';


const useStyles = makeStyles(theme => ({
  envTypeTitle: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  envOdorSection: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey.colors[9],
    borderRadius: '5px',
  },
  odorEnvSection: {
    '& > div': {
      marginBottom: theme.spacing(2),
    },
  },
  odorIndent: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1.5),
    },
  },
  iconIndent: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(-1),
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  }
}));


export default function OdorSummary(props) {
  const classes = useStyles();
  const { detectionEnvironments, detailed } = props;

  
  return (
    <>
      {!detailed && detectionEnvironments.map(env =>
        <Box mb={1} key={env.id}>
          <Typography
            variant="body2"
            className={classes.envTypeTitle}
          >
            Search of {env.count} {env.type.name + (env.count > 1 ? 's' : '')}
          </Typography>
          {env.odorEnvironments.map(odorEnv =>
            <Typography variant="body2" key={odorEnv.id}>
              {odorEnv.name}:&nbsp;
              {odorEnv.odors.length === 0
                ? 'No odors'
                : odorEnv.odors.map(odor => {
                  const odorName = odor.type.id === Types.OdorPrimary.PROOFING
                    ? odor.packaging.name
                    : `${odor.subType?.name} ${odor.type.name}`;
                  const responseCatName = odor.responseCategory
                    ? `(${odor.responseCategory.name})`
                    : '';
                  return `${odorName} ${responseCatName}`;
                }).join(', ')}
            </Typography>
          )}
        </Box>
      )}

      {detailed && detectionEnvironments.map(env =>
        <div key={env.type.id} className={classes.odorEnvSection}>
          {/* environment title */}
          <Typography variant="subtitle2">
            Search of {env.count} {env.type.name + (env.type.name !== 'Luggage' && env.count > 1 ? 's' : '') + ': '}
            
            {env.odorEnvironments.length === 0 &&
            <Typography variant="body2" component="span">
              No {env.type.name + (env.type.name !== 'Luggage' && env.count > 1 ? 's' : '')} with Odors
            </Typography>}
          </Typography>

          {env.odorEnvironments.map(odorEnv =>
            <div key={odorEnv.id} className={classes.envOdorSection}>
              {/* odor-env & description */}
              <InfoRow title={odorEnv.name} text={odorEnv.description} iconName="odor-environment" />

              {/* vehicle info */}
              {odorEnv.vehicle &&
                <Typography variant="body2" className={classes.iconIndent}>
                  {`${odorEnv.vehicle.color} ${odorEnv.vehicle.make} ${odorEnv.vehicle.model} (${odorEnv.vehicle.type.name})`}
                </Typography>}
              <div className={classes.odorIndent}>
                {odorEnv.odors.length === 0
                  ? <InfoRow title={'No Odors'} iconName="odor" />
                  : ''}
                {odorEnv.odors.map(odor =>
                  <div key={odor.id} style={{ marginTop: 8 }}>
                    {/* odor title */}
                    <InfoRow
                      title={`${odor.type.name} odor ${odor.responseCategory?.name ? `(${odor.responseCategory.name})` : ''}`}
                      text={(odor.type.id === Types.OdorPrimary.PROOFING
                        ? `${odor.packaging?.name || ''}, `
                        : odor.subType?.name ? `${odor.subType?.name}, ` : '')
                        + (`${displayNumber(odor.quantity)} ${odor.quantityUnit?.name || ''}`)}
                      iconName="odor"
                    />
                    {/* odor details */}
                    <Typography variant="body2" className={classes.iconIndent}>
                      Concealed: {odor.concealedLocation}
                      {odor.height && odor.depth && (<><br />Height: {odor.height}, Depth: {odor.depth}</>)}
                      {odor.packaging.name && odor.type.id !== Types.OdorPrimary.PROOFING && (<><br />Packaging: {odor.packaging.name}</>)}
                      {odor.description && (<><br />Description: {odor.description}</>)}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}